import { render } from "./ScenicTable.vue?vue&type=template&id=1641d366"
import script from "./ScenicTable.vue?vue&type=script&lang=js"
export * from "./ScenicTable.vue?vue&type=script&lang=js"

import "./ScenicTable.vue?vue&type=style&index=0&id=1641d366&lang=scss"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__